'use client'

import classNames from 'classnames'
import { useResponsive, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import {
  NavigationEventType,
  NavigationSelectionType,
} from '@dustin-web/microsite-components/src/utils/digital-data-types'
import { getMainCategoryIcon } from '@dustin-web/microsite-components/src/utils/main-category-icons'

export const CategoryShowAll = () => {
  const { translate } = useTranslations()

  return (
    <a
      className="d-block u-text-left u-text-md-right u-text-xl-left"
      onClick={() =>
        DigitalData.pushNavigationInteraction(
          NavigationEventType.CategoryMenu,
          'show_all_categories',
          'link_click',
          {
            selectionType: NavigationSelectionType.CategoryEntrance,
            disableSelectionSanitize: true,
          }
        )
      }
      href={translate('AllCategories_URL')}>
      {translate('Show_all_categories')}
    </a>
  )
}

type CategoryLinkProps = {
  category: {
    categoryId: string
    name: string | null | undefined
    url: string | null | undefined
  }
}

export const CategoryLink = ({ category }: CategoryLinkProps) => {
  const { breakpoints } = useResponsive()

  if (!category.url) {
    return null
  }

  return (
    <a
      className="d-flex align-items-start flex-column align-items-xl-center u-w-100 u-h-md-40 u-bg-white d-block u-px-8 u-py-8 u-px-sm-12 u-py-sm-12 u-radius-2 u-decoration-none"
      style={{ border: '1px solid black' }}
      onClick={() =>
        DigitalData.pushNavigationInteraction(
          NavigationEventType.CategoryMenu,
          category.url!,
          'link_click',
          {
            selectionType: NavigationSelectionType.CategoryEntrance,
            disableSelectionSanitize: true,
          }
        )
      }
      href={category.url}
      key={category.categoryId}>
      {getMainCategoryIcon(
        category.categoryId,
        'i-20 flex-shrink-0 u-mr-md-12 u-mb-8 u-mb-xl-0',
      )}{' '}
      <span
        className={classNames('u-fs-12 u-fs-md-14', {
          'u-line-height-1': breakpoints.min.XL,
        })}
        style={{ paddingTop: breakpoints.min.XL ? '2px' : 'initial' }}>
        {category.name}
      </span>
    </a>
  )
}
